import { RouteObject } from 'react-router-dom';

import { pagePathSegments } from '~constants';
import { CreateWebhookPage, WebhookDetailsPage, WebhooksPage } from '~features/webhooks';

const WebhookRoutes = (): RouteObject[] => {
	return [
		{
			path: pagePathSegments.Webhooks,
			children: [
				{
					index: true,
					element: <WebhooksPage />,
				},
				{
					path: pagePathSegments.Create,
					element: <CreateWebhookPage />,
				},
				{
					path: pagePathSegments.Rental,
					element: <WebhookDetailsPage type='rental' />,
				},
			],
		},
	];
};

export default WebhookRoutes;
